import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { Icon } from '@frontend/icons';
import { theme } from '@frontend/theme';
import { Dot, NakedButton, useModalControl } from '@frontend/design-system';
import { FiltersTray, FilterConfig } from './filters-tray';

type FilterTrayTriggerProps = {
  filters: FilterConfig[];
  /**
   * Current measured width of the row element in pixels.
   */
  containerWidth: number;
  /**
   * The CSS container-name of the row element.
   */
  containerName: string;
};

export const FilterTrayTrigger = ({ filters, containerWidth, containerName }: FilterTrayTriggerProps) => {
  const { t } = useTranslation('schedule');
  const { modalProps, triggerProps, openModal } = useModalControl();

  const trayFilters = filters.filter(
    (f) => (f.minInlineWidth ?? 0) > 0 && (containerWidth === 0 || containerWidth < (f.minInlineWidth ?? 0))
  );

  const hasActiveFiltersInTray = trayFilters.some((f) => f.fieldProps.value.length > 0);
  const showFilterIcon = trayFilters.length > 0;

  if (!showFilterIcon) return null;

  return (
    <div css={[styles.filterIconWrapper]}>
      <NakedButton {...triggerProps} css={styles.filterIconButton} aria-label={t('Open filters')} onClick={openModal}>
        <Icon name='filter-alt' size={16} color='default' />
        {hasActiveFiltersInTray && (
          <Dot
            color='primary'
            css={{ width: 8, height: 8, top: 6, left: 22, border: `1px solid ${theme.colors.white}` }}
          />
        )}
      </NakedButton>
      <FiltersTray modalProps={modalProps} filters={trayFilters} containerName={containerName} />
    </div>
  );
};

const styles = {
  filterIconWrapper: css`
    flex-shrink: 0;
    display: flex;
    align-items: center;
  `,
  filterIconButton: css`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: var(--fabric-radius-sm);
    border: 1px solid ${theme.colors.neutral20};
    background-color: ${theme.colors.white};
    height: 32px;
    padding: 0 var(--fabric-space-gap-xs);
    box-sizing: border-box;
  `,
};
